import React from "react";
import { Box, IconButton, styled } from "@mui/material";
import { TYPES, LAYOUTS } from "./CopyPaste.consts";

const StyledBox = styled(Box, {
  shouldForwardProp: prop => prop !== "type"
})(() => ({
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)"
}));

const Wrapper = ({ useWrapper, children, type }) => {
  if (!useWrapper) return children;
  return <StyledBox type={type}>{children}</StyledBox>;
};

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== "type" && prop !== "size" && prop !== "layout"
})(({ theme, type, size, layout }) => ({
  height: size,
  width: size,
  backgroundColor: type === TYPES.ELAVATED ? theme.palette.system[50] : theme.palette.system[0],
  borderRadius: layout === LAYOUTS.CIRCLE ? "50%" : `${theme.shape.borderRadius * 0.5}px`,
  "&:focus, &:focus-visible": {
    outline: "none",
  },
  "& .MuiTouchRipple-root": {
    display: "none",
  },
}));

export {
  Wrapper,
  StyledIconButton
};
